import { http } from "services/http";

import type { MainIndicators, Statistics, StatisticsPeriodRequest } from "models/dashboard.model";

export const dashboardApi = {
  getData: () => http.quiet().post<Statistics>("/api/statistics", {}),
  getPeriodStat: (data: StatisticsPeriodRequest) =>
    http.quiet().post<MainIndicators>("/api/statistics/main-indicators-by-period", { ...data }),
};
